module.exports = __webpack_public_path__ + "img/25.c2bfef60.jpeg";